import {ActionTypes} from "modules/redux_types";
import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};

const types = [
  "ISSUE_OVERRIDE_TAGS_FETCH",
  "ISSUE_OVERRIDE_TAGS_CLEAR",
  "ISSUE_OVERRIDE_TAG_REMOVE",
  "ISSUE_OVERRIDE_TAG_UPDATE",
] as const;

types.forEach(type => createReduxPromiseActionType(actionTypes, type));

export type ActionType = typeof types[number];

export type TagActionTypes = ActionTypes<ActionType>;

export default actionTypes as TagActionTypes;
